import { colors, Typography } from '@sweep-io/sweep-design';
import { CardTypes, AiAssistantConversation, DataCardDetails } from './types';
import { getCountByType, getPercentageByType } from './utils';
import Stack from '@mui/material/Stack';
import { ChevronUp, ChevronDown } from '@sweep-io/sweep-design/dist/icons';

export const allCardDetails: { [key in CardTypes]: DataCardDetails } = {
  [CardTypes.TotalSupportRequests]: {
    text: 'Total support requests',
    type: CardTypes.TotalSupportRequests,
  },
  [CardTypes.ResolutionRate]: {
    text: 'Resolution rate',
    type: CardTypes.ResolutionRate,
  },
  [CardTypes.AdminSupportRequests]: {
    text: 'Pending admin response',
    type: CardTypes.AdminSupportRequests,
  },
  [CardTypes.InProgress]: {
    text: 'In progress rate',
    type: CardTypes.InProgress,
  },
};

export const DataCard = (
  type: CardTypes,
  tableData: AiAssistantConversation[],
  startDate: string,
  endDate: string,
  isCollapsed?: boolean,
) => {
  const cardDetails = allCardDetails[type];
  const itemCount = getCountByType(type, tableData, startDate, endDate);
  const itemPercentage = getPercentageByType(type, tableData, startDate, endDate);
  const isPercentageGrowing = itemPercentage > 0;
  const percentageColor = isPercentageGrowing ? colors.mint[700] : colors.feedback.destructive;

  return (
    <Stack
      sx={{
        gap: 1,
        p: isCollapsed ? '12px 16px' : '12px 24px',
        flex: 1,
      }}
    >
      <Typography variant={isCollapsed ? 'caption' : 'body'} color={colors.grey[700]}>
        {cardDetails.text}
      </Typography>

      <Stack direction="row" alignItems="center" gap={1}>
        <Typography variant={isCollapsed ? 'h2' : 'h1'} color={colors.grey[900]}>
          {itemCount}
          {type !== CardTypes.TotalSupportRequests && itemCount !== 0 ? '%' : ''}
        </Typography>

        {itemPercentage === 0 ? null : (
          <Stack direction="row" alignItems="center" gap={0.5}>
            {isPercentageGrowing ? (
              <ChevronUp color={percentageColor} />
            ) : (
              <ChevronDown color={percentageColor} />
            )}
            <Typography variant={isCollapsed ? 'body' : 'body-medium'} color={percentageColor}>
              {itemPercentage} %
            </Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
